import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import axios from 'axios';
import * as qs from 'qs';
import * as Cookie from 'js-cookie';
export function toFormData(params) {
  var formData = new FormData();
  if (!params) {
    return formData;
  }
  Object.entries(params).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    if (Array.isArray(value)) {
      value.forEach(function (val) {
        formData.append(key, val);
      });
    } else {
      formData.set(key, value);
    }
  });
  return formData;
}
/**
 * 创建一个请求实例
 * @param config AxiosRequestConfig
 */
export function create(config) {
  var http = axios.create(config);
  var stepinHttp = http;
  stepinHttp.request = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url, method, params, config) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = method;
              _context.next = _context.t0 === 'GET' ? 3 : _context.t0 === 'POST' ? 4 : _context.t0 === 'POST_JSON' ? 5 : _context.t0 === 'PUT' ? 6 : _context.t0 === 'PUT_JSON' ? 7 : _context.t0 === 'DELETE' ? 8 : _context.t0 === 'HEAD' ? 9 : _context.t0 === 'OPTIONS' ? 10 : _context.t0 === 'PATCH' ? 11 : _context.t0 === ('PURGE' || 'LINK' || 'UNLINK') ? 12 : 13;
              break;
            case 3:
              return _context.abrupt("return", this.get(url, _objectSpread({
                params: params,
                paramsSerializer: function paramsSerializer(data) {
                  return qs.stringify(data, {
                    indices: false,
                    skipNulls: true
                  });
                }
              }, config)));
            case 4:
              return _context.abrupt("return", this.post(url, toFormData(params), config));
            case 5:
              return _context.abrupt("return", this.post(url, params, config));
            case 6:
              return _context.abrupt("return", this.put(url, toFormData(params), config));
            case 7:
              return _context.abrupt("return", this.put(url, params, config));
            case 8:
              return _context.abrupt("return", this.delete(url, _objectSpread({
                data: toFormData(params)
              }, config)));
            case 9:
              return _context.abrupt("return", this.head(url, _objectSpread({
                params: params
              }, config)));
            case 10:
              return _context.abrupt("return", this.options(url, _objectSpread({
                params: params
              }, config)));
            case 11:
              return _context.abrupt("return", this.patch(url, _objectSpread({
                params: params
              }, config)));
            case 12:
              return _context.abrupt("return", axios.request(_objectSpread({
                url: url,
                method: method,
                params: params
              }, this.defaults)));
            case 13:
              return _context.abrupt("return", axios.request(_objectSpread({
                url: url,
                method: method,
                params: params
              }, this.defaults)));
            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));
    return function (_x, _x2, _x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();
  // 设置token
  stepinHttp.setAuthorization = function (token, expires, name) {
    Cookie.set(name !== null && name !== void 0 ? name : this.defaults.xsrfCookieName, token, {
      expires: expires
    });
  };
  // 移出token
  stepinHttp.removeAuthorization = function (name) {
    Cookie.remove(name !== null && name !== void 0 ? name : this.defaults.xsrfCookieName);
  };
  // 校验token
  stepinHttp.checkAuthorization = function (name) {
    return Boolean(Cookie.get(name !== null && name !== void 0 ? name : this.defaults.xsrfCookieName));
  };
  // 使用请求拦截器
  stepinHttp.useRequestInterceptors = function (app, interceptor) {
    var _interceptor$onFulfil = interceptor.onFulfilled,
      onFulfilled = _interceptor$onFulfil === void 0 ? function (config) {
        return config;
      } : _interceptor$onFulfil,
      _interceptor$onReject = interceptor.onRejected,
      onRejected = _interceptor$onReject === void 0 ? function (error) {
        return error;
      } : _interceptor$onReject;
    this.interceptors.request.use(function (config) {
      return onFulfilled(config, app);
    }, function (error) {
      return onRejected(error, app);
    });
    return this;
  };
  // 使用响应拦截器
  stepinHttp.useResponseInterceptors = function (app, interceptor) {
    var _interceptor$onFulfil2 = interceptor.onFulfilled,
      onFulfilled = _interceptor$onFulfil2 === void 0 ? function (response) {
        return response;
      } : _interceptor$onFulfil2,
      _interceptor$onReject2 = interceptor.onRejected,
      onRejected = _interceptor$onReject2 === void 0 ? function (error) {
        return error;
      } : _interceptor$onReject2;
    this.interceptors.response.use(function (response) {
      return onFulfilled(response, app);
    }, function (error) {
      return onRejected(error, app);
    });
    return this;
  };
  return stepinHttp;
}
var authorization = 'Authorization';
// default StepinHttp instance
export var stepinHttp = create({
  timeout: 10000,
  withCredentials: true,
  xsrfHeaderName: authorization,
  xsrfCookieName: authorization
});
var _StepinHttp = {
  http: stepinHttp,
  create: create
};
export default _StepinHttp;